










import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import QuestionGroupFormFields from "./partials/QuestionGroupFormFields.vue"

@Component({
  components: {
    QuestionGroupFormFields
  },
  computed: {
    ...mapState({
      loading: "loading"
    }),
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup"
    })
  }
})
export default class QuestionGroupCreate extends Vue {
  questionGroup!: {
    object_id: string;
    name: string;
    description: string;
    display_order: number;
  }

  loading!: boolean

  handleCreate() {
    this.$store
      .dispatch("QuestionGroup/create", {
        ...this.questionGroup,
        status: "STATUS_PUBLISHED"
      })
      .then(() => {
        this.$store.commit("SET_SNACKBAR", {
          show: true,
          type: "success",
          message: "The question group is created successfully."
        })
        this.$router.push({
          name: "administrator-question-group-update",
          params: {
            questionGroupOid: this.questionGroup.object_id
          }
        })
      })
      .catch(error => {
        this.$store.commit("SET_LOADING", false)
        const errorMessages = Object.keys(error.response.data.error)
          .map(key => error.response.data.error[key])
          .join()
        this.$store.commit("SET_SNACKBAR", {
          show: true,
          type: "error",
          message: errorMessages
        })
      })
  }

  handleSaveAsDraft() {
    this.$store
      .dispatch("QuestionGroup/create", {
        ...this.questionGroup,
        status: "STATUS_DRAFT"
      })
      .then(() => {
        this.$store.commit("SET_SNACKBAR", {
          show: true,
          type: "success",
          message: "The question group is saved as draft successfully."
        })
        this.$router.push({
          name: "administrator-question-group-update",
          params: {
            questionGroupOid: this.questionGroup.object_id
          }
        })
      })
      .catch(error => {
        this.$store.commit("SET_LOADING", false)
        const errorMessages = Object.keys(error.response.data.error)
          .map(key => error.response.data.error[key])
          .join()
        this.$store.commit("SET_SNACKBAR", {
          show: true,
          type: "error",
          message: errorMessages
        })
      })
  }

  beforeDestroy() {
    this.$store.commit("QuestionGroup/CLEAR_STATE")
  }
}
